import React, { memo } from "react";
import Constants from "../constants/Constants";
import LazyLoad from "react-lazyload";
import ProgressiveImage from "react-progressive-image";
import { Link } from "@reach/router";

const ModelArchiveThumbs = (props) => {
  const {
    video,
    tags,
    file,
    isActive,
    join,
    site,
    actives,
    modelName,
    dispatch,
  } = props;
  const goToVideo = () => {
    const height =
      (window.pageYOffset || document.documentElement.scrollTop) -
      (document.documentElement.clientTop || 0);
    setTimeout(() => {
      dispatch({
        type: "scrollTo",
        site: modelName,
        payload: height,
      });
    }, 1500);
  };
  const handleNonActive = (e) => {
    if (
      !isActive &&
      (file.trailer === "2" || file.trailer === "0") &&
      video.site_id !== "0"
    ) {
      if (modelName === "favorites") {
        if (actives.includes(video.site_id)) {
          goToVideo();
        } else {
          join(site);
          e.preventDefault();
        }
      } else {
        if (modelName === "library") {
          goToVideo();
        } else {
          join(site);
          e.preventDefault();
        }
      }
    } else {
      goToVideo();
    }
  };
  return (
    <div className="thumb">
      <Link
        to={`${Constants.MA}video/${video.id}`}
        className="th"
        onClick={(e) => handleNonActive(e)}
        state={{ hasBack: true }}
      >
        <LazyLoad height={374} once>
          <ProgressiveImage
            src={
              Math.random() > 0.6
                ? `https://static.addfriends.com/vip/posters/${file.file_name.replace(
                    ".mp4",
                    ".gif"
                  )}`
                : `https://static.addfriends.com/vip/posters/${file.file_name.replace(
                    ".mp4",
                    ".jpg"
                  )}`
            }
            placeholder={`https://static.addfriends.com/vip/posters/${file.file_name.replace(
              ".mp4",
              "-sm.jpg"
            )}`}
          >
            {(src) => <img src={src} alt={`${video.title}`} />}
          </ProgressiveImage>
        </LazyLoad>
        <div className="inform">
          <div className="name">{video.title}</div>
          <div className="tags">{tags}</div>
        </div>
      </Link>
    </div>
  );
};

export default memo(ModelArchiveThumbs, (prev, next) => true);
